//NPM Packages
import React, { useState, useContext } from "react";
import axios from "axios";
import styled from "styled-components";

//Context
import MyContext from "../context/MyContext";

//Components
import { Col } from "../components/styles/Col";
import { Form as PersonalInfoForm } from "../components/styles/Form.styled";
import { Form as DoneForm } from "../components/styles/Form.styled";
import Header from "../components/Header";
import { Input } from "../components/styles/Input.styled";
import { Row } from "../components/styles/Row";
import { TextArea } from "../components/styles/TextArea.styled";
import { Wrapper } from "../components/styles/Wrapper.styled";

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  margin-top: 1rem;
`;

const FormWrapper = styled.div`
  padding: ${(props) => props.theme.space[1]};

  @media ${({ theme }) => theme.device.mobileL} {
    padding: ${(props) => props.theme.space[2]};
  }

  @media ${({ theme }) => theme.device.laptop} {
    padding: ${(props) => props.theme.space[3]};
  }
`;

const FormHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: x-large;
  font-weight: bold;
`;

const FormSubHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: large;
`;

const FormBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: large;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  border: 1px solid #bbb;
  border-radius: 3px;
  width: 100%;
`;

const Label = styled.label`
  padding: ${(props) => props.theme.space[1]};
  font-size: medium;
`;

const ValidationMessage = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: small;
  color: red;
`;

const ValidationSubHeading = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: large;
  color: red;
`;

const DiscoveryBankLeads = (props) => {
  const {
    dev,
    headers,
    data,
    setData,
    lamininSubmitted,
    setLamininSubmitted,
    lamininSent,
    setLamininSent,
    lamininError,
    setLamininError,
    setLamininResponse,
    personalInfoCaptured,
    setPersonalInfoCaptured,
  } = useContext(MyContext);

  const [formError, setFormError] = useState("");
  const [idNumberError, setIdNumberError] = useState("");
  const [mobileError, setMobileError] = useState("");

  const handlePersonalInfoChange = (event) => {
    const { name, value } = event.target;
    setData((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };

  const handlePersonalInfoSubmit = (event) => {
    event.preventDefault();
    let isValid = true;

    // ID number validation
    if (data.idNumber !== "") {
      if (data.idNumber.length !== 13 || isNaN(data.idNumber)) {
        setIdNumberError(
          "Please enter a valid 13-digit ID number without any spaces"
        );
        isValid = false;
      } else {
        setIdNumberError("");
        setFormError("");
      }
    }

    // Mobile number validation
    if (data.mobile.length !== 10 || isNaN(data.mobile)) {
      setMobileError(
        "Please enter a valid 10-digit phone number without any spaces, example 0812345678"
      );
      isValid = false;
    } else {
      setMobileError("");
      setFormError("");
    }

    if (!isValid) {
      setFormError(
        "Note: There are errors on this form. Please correct and click on Next to continue."
      );
      window.scrollTo(0, 0);
    }

    if (isValid) {
      setData((prevValue) => {
        return {
          ...prevValue,
          sourceRef: "BPO App",
        };
      });
      setPersonalInfoCaptured(true);
      submitToLaminin();
    }
  };

  const submitToLaminin = () => {
    setLamininSubmitted(true);

    axios
      .post(dev ? "http://localhost:5000/api/create" : "api/create", data, {
        headers: headers,
      })
      .then(
        (response) => {
          if (response.status === 200) {
            setLamininResponse(response.data);
            console.log("Laminin Response OK: " + response.status);
            const { NewLeadId } = response.data;
            setData((prevValue) => {
              return {
                ...prevValue,
                leadId: NewLeadId,
              };
            });
            setLamininSent(true);
          } else {
            console.log("Laminin Response Not OK: " + response.status);
            setLamininError(true);
          }
        },
        (error) => {
          console.log("Laminin Response Error: " + error);
          setLamininError(true);
        }
      );

    setData({
      firstName: "",
      lastName: "",
      idNumber: "",
      mobile: "",
      email: "",
      message: "",
    });
  };

  return (
    <Wrapper>
      <Header
        name="Discovery Bank | Laminin"
        description="Discovery Bank. The Future of Banking. Now."
        logoPath="../images/discovery-bank.png"
      />
      <FormWrapper>
        {!personalInfoCaptured && (
          <PersonalInfoForm onSubmit={handlePersonalInfoSubmit}>
            <FormHeading>Discovery Bank Credit Card - Apply Today!</FormHeading>
            <FormSubHeading>
              Please complete your information below and one of our Private
              Bankers will contact you
            </FormSubHeading>
            {formError && (
              <ValidationSubHeading>{formError}</ValidationSubHeading>
            )}
            <FormBody>
              <ItemWrapper>
                <Label>Personal Information</Label>
                <Row>
                  <Col $md={6} style={{ padding: "0 1% 0 0" }}>
                    <Input
                      type="text"
                      name="firstName"
                      onChange={handlePersonalInfoChange}
                      placeholder="First Name (Required)"
                      required={true}
                      value={data.firstName}
                      width="100%"
                    />
                  </Col>
                  <Col $md={6} style={{ padding: "0 1% 0 0" }}>
                    <Input
                      type="text"
                      name="lastName"
                      onChange={handlePersonalInfoChange}
                      placeholder="Last Name (Required)"
                      required={true}
                      value={data.lastName}
                      width="100%"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col $md={6} style={{ padding: "0 1% 0 0" }}>
                    <Input
                      type="text"
                      name="idNumber"
                      onChange={handlePersonalInfoChange}
                      placeholder="ID Number (Required)"
                      required={true}
                      value={data.idNumber}
                      width="100%"
                      maxLength={13}
                    />
                    {idNumberError && (
                      <ValidationMessage>{idNumberError}</ValidationMessage>
                    )}
                  </Col>
                  <Col $md={6} style={{ padding: "0 1% 0 0" }}>
                    <Input
                      type="text"
                      name="mobile"
                      onChange={handlePersonalInfoChange}
                      placeholder="Mobile Number (Required)"
                      required={true}
                      value={data.mobile}
                      width="100%"
                      maxLength={10}
                    />
                    {mobileError && (
                      <ValidationMessage>{mobileError}</ValidationMessage>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col $md={6} style={{ padding: "0 1% 0 0" }}>
                    <Input
                      type="email"
                      name="email"
                      onChange={handlePersonalInfoChange}
                      placeholder="Email"
                      required={false}
                      value={data.email}
                      width="100%"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col $md={6} style={{ padding: "0 1% 0 0" }}>
                    <TextArea
                      type="textarea"
                      name="message"
                      onChange={handlePersonalInfoChange}
                      placeholder="Message"
                      required={false}
                      value={data.message}
                      width="100%"
                      maxLength={450}
                    />
                    <Label>
                      Characters remaining: {450 - data.message.length}
                      /450
                    </Label>
                  </Col>
                </Row>
              </ItemWrapper>
            </FormBody>
            <ButtonWrapper>
              <button className="btn btn-dark btn-lg" type="submit">
                Submit
              </button>
            </ButtonWrapper>
          </PersonalInfoForm>
        )}

        {personalInfoCaptured &&
          lamininSubmitted &&
          !(lamininSent || lamininError) && (
            <DoneForm>
              <FormHeading>Processing...</FormHeading>
              <FormSubHeading>
                Submitting your information, please stand by...
              </FormSubHeading>
            </DoneForm>
          )}

        {personalInfoCaptured && lamininSent && (
          <DoneForm>
            <FormHeading>Complete!</FormHeading>
            <FormSubHeading>
              Thank you for submitting your information, your Reference Number
              (Laminin Lead ID) is {data.leadId}. One of our representatives
              will be in contact with you shortly.
            </FormSubHeading>
          </DoneForm>
        )}

        {personalInfoCaptured && lamininError && (
          <DoneForm>
            <FormHeading>Something went wrong</FormHeading>
            <FormSubHeading>
              Your information was not received, we apologise for the
              inconvenience. Please contact us on 010 054 5575.
            </FormSubHeading>
          </DoneForm>
        )}
      </FormWrapper>
    </Wrapper>
  );
};

export default DiscoveryBankLeads;
